import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';

import { DevFlag, injectDevFlag } from '@recruitee/dev-flags-data';
import { TranslatePipe } from '@recruitee/i18n';
import { SupportedThemesT } from '@recruitee/theme';
import { ButtonComponent, HeadingComponent, IconComponent } from '@recruitee/user-interface';

import { SvgAssetComponent } from '../../../common';

@Component({
  selector: 'rt-kiwi-hr-promo',
  template: `
    <rti-svg-asset [name]="logotype()" centerHorizontally="false" margin-bottom></rti-svg-asset>
    <div layout-vertical>
      <rt-heading
        [variant]="headingVariant()"
        [attr.margin-bottom-small-x]="hasHeadingMarginBottom() || null"
      >
        {{ 'rti.kiwi_hr.promo.heading' | translate }}
      </rt-heading>
      <span
        [attr.text-semi-medium]="subheadingFontWeight() === 'medium' || null"
        [attr.text-darkest]="hasSubheadingStrongColor() || null"
      >
        {{ 'rti.kiwi_hr.promo.subheading' | translate }}
      </span>
    </div>
    <rt-button
      variant="kiwihr"
      (click)="ctaClick.emit()"
      [attr.margin-top-large]="hasButtonLargeMarginTop() || null"
      [attr.margin-top-medium]="!hasButtonLargeMarginTop() || null"
    >
      {{ 'rti.kiwi_hr.promo.cta' | translate }}
      <rt-icon name="open-in-new" colorToken="colorIconOnprimaryDefault"></rt-icon>
    </rt-button>
  `,
  styleUrl: 'kiwi-hr-promo.component.less',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, IconComponent, HeadingComponent, TranslatePipe, SvgAssetComponent],
  host: {
    '[class.button-fit-content]': 'buttonFitContent()',
    '[class.has-padding]': 'hasPadding()',
  },
})
export class KiwiHrPromoComponent {
  protected readonly hasNewCandidateProfile = injectDevFlag(DevFlag.CandidateProfileRefresh);

  public hasBigHeading = input.required<boolean, boolean | string>({ transform: booleanAttribute });

  public buttonFitContent = input.required<boolean, boolean | string>({
    transform: booleanAttribute,
  });

  public hasButtonLargeMarginTop = input.required<boolean, boolean | string>({
    transform: booleanAttribute,
  });

  public hasHeadingMarginBottom = input.required<boolean, boolean | string>({
    transform: booleanAttribute,
  });

  public subheadingFontWeight = input.required<'default' | 'medium'>();

  public hasPadding = input.required<boolean, boolean | string>({ transform: booleanAttribute });

  public theme = input.required<SupportedThemesT>();

  public hasSubheadingStrongColor = input<boolean, boolean | string>(false, {
    transform: booleanAttribute,
  });

  public ctaClick = output<void>();

  protected headingVariant = computed(() =>
    this.hasBigHeading() ? 'heading large-x-dialog-header' : 'heading',
  );

  protected logotype = computed(() =>
    this.theme() === 'dark' ? 'recruiteeKiwiDark' : 'recruiteeKiwiLight',
  );
}
